export function triggerEvent(element, type) {
  const eventDOM = document.createEvent('HTMLEvents');
  eventDOM.initEvent(type, true, false);
  element.dispatchEvent(eventDOM);
}
